"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _core = require("@material-ui/core");

var _commons = require("egov-ui-kit/utils/commons");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _reactRedux = require("react-redux");

var _action = require("egov-ui-kit/redux/module/action");

var _api = require("egov-ui-kit/utils/api");

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _components = require("egov-ui-kit/components");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import the pagination CSS file

var CustomPagination = function (_Component) {
  (0, _inherits3.default)(CustomPagination, _Component);

  function CustomPagination(props) {
    (0, _classCallCheck3.default)(this, CustomPagination);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomPagination.__proto__ || Object.getPrototypeOf(CustomPagination)).call(this, props));

    _this.updateItemsRange = function () {
      // const { currentPage, itemsPerPage } = this.state;
      // const { data } = this.props;
      // const itemsRangeStart = (currentPage - 1) * itemsPerPage + 1;
      // const itemsRangeEnd = Math.min(currentPage * itemsPerPage, data.length + (currentPage - 1) * itemsPerPage + 1);
      // this.setState({ itemsRangeStart, itemsRangeEnd });
      var _this$props = _this.props,
          data = _this$props.data,
          stateName = _this$props.stateName;

      var dataArray = (0, _get2.default)(_store2.default.getState().screenConfiguration.preparedFinalObject, stateName, []);
      var _this$state = _this.state,
          currentPage = _this$state.currentPage,
          itemsPerPage = _this$state.itemsPerPage;

      var itemsRangeStart = (currentPage - 1) * 20 + 1;
      var itemsRangeEnd = Math.min(currentPage * 20, data.length + (currentPage - 1) * 20);
      _this.setState({ itemsRangeStart: itemsRangeStart, itemsRangeEnd: itemsRangeEnd });
    };

    _this.handleClick = function (e, page) {
      _this.handleSearch(page);
      e.preventDefault();
    };

    _this.handleItemsPerPageChange = function (e) {
      _this.setState({
        itemsPerPage: parseInt(e.target.value),
        currentPage: 1 // Reset to first page when changing items per page
      });
    };

    _this.state = {
      currentPage: 1,
      itemsPerPage: 20, // Default number of items per page
      itemsRangeStart: 0,
      itemsRangeEnd: 0,
      loaderVisibility: false
    };
    return _this;
  }

  (0, _createClass3.default)(CustomPagination, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateItemsRange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var updateCalled = (0, _get2.default)(_store2.default.getState().screenConfiguration, "preparedFinalObject.updateCalled", false);
      if (!updateCalled) {
        this.setState({ currentPage: 1, itemsPerPage: 20 });
        _store2.default.dispatch((0, _actions.prepareFinalObject)("updateCalled", true));
      }
      if (prevState.currentPage !== this.state.currentPage || prevState.itemsPerPage !== this.state.itemsPerPage || prevProps.data.length !== this.props.data.length) {
        this.updateItemsRange();
      }
    }
  }, {
    key: "actionButtonHandler",
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(value, operationType) {
        var cafRequest2Data, caf2Details, queryObject, _queryObject;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (value) {
                  cafRequest2Data = (0, _get2.default)(_store2.default.getState().screenConfiguration, "preparedFinalObject.cafRequest2Data", "") || {};
                  caf2Details = cafRequest2Data.filter(function (el) {
                    return el.planCaseNo == value;
                  });


                  if (operationType == "view") {
                    _store2.default.dispatch((0, _actions.prepareFinalObject)("cafRequest2Data", {
                      data: caf2Details,
                      operationType: operationType
                    }));
                    (0, _commons.setRoute)("/egov-waterdrainage/EODB/CAF2ApplicationDetails");
                  } else if (operationType == "form1") {
                    queryObject = [{
                      key: "reportName",
                      value: "CAF2_FORM1"
                    }, {
                      key: "planCaseNo",
                      value: value
                    }, {
                      key: "assesseeNo",
                      value: caf2Details[0].assesseeNo
                    }, {
                      key: "ccCaseNo",
                      value: caf2Details[0].ccCaseNo
                    }];

                    (0, _commons.handleReport)(queryObject);
                  } else if (operationType == "form2") {
                    _queryObject = [{
                      key: "reportName",
                      value: "CAF2_FORM2"
                    }, {
                      key: "planCaseNo",
                      value: value
                    }, {
                      key: "zone",
                      value: 1
                    }];

                    (0, _commons.handleReport)(_queryObject);
                  }
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function actionButtonHandler(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return actionButtonHandler;
    }()
  }, {
    key: "actionButtonHandlerCAF1",
    value: function actionButtonHandlerCAF1(value, operationType) {
      if (value) {
        var cafRequestData = (0, _get2.default)(_store2.default.getState().screenConfiguration, "preparedFinalObject.cafRequestData", "") || {};

        var cafRequest = cafRequestData.filter(function (el) {
          return el.planCaseNo == value;
        });

        if (cafRequest && cafRequest.length > 0) {
          _store2.default.dispatch((0, _actions.prepareFinalObject)("cafRequest", {
            data: cafRequest[0],
            operationType: operationType
          }));
          (0, _commons.setRoute)("/egov-waterdrainage/EODB/CAFRequestSearch/Update");
        }
      }
    }
  }, {
    key: "onClickPrint",
    value: function onClickPrint(value, form) {
      if (form == "form1") {
        var queryObject = [{
          key: "reportName",
          value: "CAF_FORM1"
        }, {
          key: "planCaseNo",
          value: value
        }];
        (0, _commons.handleReport)(queryObject);
      } else {
        var _queryObject2 = [{
          key: "reportName",
          value: "CAF_FORM2"
        }, {
          key: "planCaseNo",
          value: value
        }, {
          key: "zone",
          value: 1
        }];
        (0, _commons.handleReport)(_queryObject2);
      }
    }
  }, {
    key: "returnButtonCAF1",
    value: function returnButtonCAF1(value, planCaseNo, isDemandPaid) {
      var _this2 = this;

      if (value !== "C" || isDemandPaid !== "Y") {
        return _react2.default.createElement(
          _core.Grid,
          { container: true, spacing: 11, alignItems: "center" },
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 10, sm: 10 },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this2.actionButtonHandlerCAF1(planCaseNo);
                } },
              "VIEW"
            ),
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this2.onClickPrint(planCaseNo, "form1");
                } },
              "FORM-1"
            )
          )
        );
      } else {
        return _react2.default.createElement(
          _core.Grid,
          { container: true, spacing: 11, alignItems: "center" },
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 10, sm: 10 },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this2.actionButtonHandlerCAF1(planCaseNo);
                } },
              "VIEW"
            ),
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this2.onClickPrint(planCaseNo, "form1");
                } },
              "FORM-1"
            ),
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this2.onClickPrint(planCaseNo, "form2");
                } },
              "FORM-2"
            )
          )
        );
      }
    }
    // actionButtonHandlerCAF1(value, operationType) {
    //   if (value) {
    //     let cafRequestData = get(store.getState().screenConfiguration, "preparedFinalObject.cafRequestData", "") || {};

    //     let cafRequest = cafRequestData.filter((el) => {
    //       return el.planCaseNo == value;
    //     });

    //     if (cafRequest && cafRequest.length > 0) {
    //       store.dispatch(
    //         prepareFinalObject("cafRequest", {
    //           data: cafRequest[0],
    //           operationType,
    //         })
    //       );
    //       setRoute("/egov-waterdrainage/EODB/CAFRequestSearch/Update");
    //     }
    //   }
    // }

  }, {
    key: "returnButtonConnection",
    value: function returnButtonConnection(status, value, connType) {
      var _this3 = this;

      var statusAction = void 0;
      var requestStatus = void 0;
      if (status == "A") {
        statusAction = "Disconnect";
        requestStatus = "DISCONNECT";
      } else if (status == "I") {
        statusAction = "Reconnect";
        requestStatus = "RECONNECT";
      }
      return _react2.default.createElement(
        _core.Grid,
        { container: true, spacing: 3, alignItems: "center" },
        localStorage.getItem("rolename") !== "NEFT/RTGS ADJUSTMENT USER" && _react2.default.createElement(
          _core.Grid,
          { item: true, xs: 6 },
          _react2.default.createElement(
            _core.Button,
            {
              style: (0, _extends3.default)({}, _commons.styles.acceptButton, {
                minWidth: "50px",
                maxWidth: "50px",
                maxHeight: "36px",
                marginLeft: "50px"
              }),
              onClick: function onClick() {
                return _this3.statusAction(requestStatus, value, connType);
              }
            },
            statusAction
          )
        )
      );
    }
  }, {
    key: "statusAction",
    value: function statusAction(status, accountNo, connType) {
      this.props.updateModule({ key: "connection", value: "" });
      this.props.updateFieldValue("layout[6].children[0].props.open", true);

      if (status == "RECONNECT") {
        this.props.updateFieldValue("layout[6].children[0].children[1].children[0].children[1].children[0].children[0].children[0].children[0].props.visible", false);
      } else if (status == "DISCONNECT") {
        this.props.updateFieldValue("layout[6].children[0].children[1].children[0].children[1].children[0].children[0].children[0].children[1].props.visible", false);
      } else {
        this.props.updateFieldValue("layout[6].children[0].children[1].children[0].children[1].children[0].children[0].children[0].children[0].props.visible", false);
        this.props.updateFieldValue("layout[6].children[0].children[1].children[0].children[1].children[0].children[0].children[0].children[1].props.visible", false);
      }

      this.props.updateModule({ key: "connection.status", value: status });
      this.props.updateModule({ key: "connection.accountNo", value: accountNo });
      this.props.updateModule({ key: "connection.connType", value: connType });
    }
  }, {
    key: "returnButton",
    value: function returnButton(value, planCaseNo, isDemandPaid) {
      var _this4 = this;

      if (value !== "C" || isDemandPaid !== "Y") {
        return _react2.default.createElement(
          _core.Grid,
          { container: true, spacing: 2, alignItems: "center", direction: "column" },
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 5, style: { marginBottom: "5px" } },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this4.actionButtonHandler(planCaseNo, "view");
                } },
              "View"
            )
          ),
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 5, style: { marginBottom: "5px" } },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this4.actionButtonHandler(planCaseNo, "form1");
                } },
              "Form 1"
            )
          ),
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 5, style: { marginBottom: "5px" } },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this4.actionButtonHandler(planCaseNo, "download");
                } },
              "Download"
            )
          )
        );
      } else {
        return _react2.default.createElement(
          _core.Grid,
          { container: true, spacing: 2, alignItems: "center", direction: "column" },
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 5, style: { marginBottom: "5px" } },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this4.actionButtonHandler(planCaseNo, "view");
                } },
              "View"
            )
          ),
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 5, style: { marginBottom: "5px" } },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this4.actionButtonHandler(planCaseNo, "form1");
                } },
              "Form 1"
            )
          ),
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 5, style: { marginBottom: "5px" } },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this4.actionButtonHandler(planCaseNo, "form2");
                } },
              "Form 2"
            )
          ),
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 5, style: { marginBottom: "5px" } },
            _react2.default.createElement(
              _core.Button,
              { style: _commons.styles.acceptButton, onClick: function onClick() {
                  return _this4.actionButtonHandler(planCaseNo, "download");
                } },
              "Download"
            )
          )
        );
      }
    }
  }, {
    key: "handleSearch",
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(page) {
        var _this5 = this;

        var value, queryObject, dateExpression, res, _state, currentPage, itemsPerPage, _props, tableDataPath, paginationDataPath, stateName, stateNameData, responseObject, dataRaw, data, layoutJsonNew, message;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // get the appelant details value
                this.setState({ loaderVisibility: true });
                value = (0, _get2.default)(_store2.default.getState().moduleData, this.props.query ? this.props.query : this.props.stateNameData, {});
                queryObject = [{
                  key: "pageNumber",
                  value: page
                }];

                if (this.props.responseObject === "WSParameter") {
                  queryObject.push({ key: "departmentCode", value: "W" });
                }

                dateExpression = /^\d{4}-\d{2}-\d{2}$/;


                if (value && Object.keys(value).length > 0) {
                  // loop the values object and push those keys, whose values exist
                  value && Object.keys(value).forEach(function (key) {
                    if (dateExpression.test(value[key])) {
                      queryObject.push({ key: key, value: (0, _commons.formatDateForWaterPayload)(value[key]) });
                    } else if (value[key]) {
                      queryObject.push({ key: key, value: value[key] });
                    }
                  });
                }
                _context2.next = 8;
                return (0, _api.httpRequestForPT)(this.props.endpoint, "", queryObject);

              case 8:
                res = _context2.sent;

                this.setState({ loaderVisibility: false });

                if (res.tokenStatus == "invalid") {
                  (0, _commons.showToast)("Invalid Access Token. Please login again", "error");
                } else if (res.tokenStatus == "valid" && [200, 201].includes(res.status)) {
                  _state = this.state, currentPage = _state.currentPage, itemsPerPage = _state.itemsPerPage;
                  _props = this.props, tableDataPath = _props.tableDataPath, paginationDataPath = _props.paginationDataPath, stateName = _props.stateName, stateNameData = _props.stateNameData, responseObject = _props.responseObject;
                  dataRaw = stateNameData === "regularDemand" || stateNameData == "drainageDemand" ? res.data[responseObject]["demands"] : res.data[responseObject];
                  data = dataRaw.length > 0 ? dataRaw.map(function (item, index) {
                    return (0, _extends3.default)({}, item, {
                      srlNo: (page - 1) * 20 + index + 1
                    });
                  }) : [];

                  if (stateNameData == "cafRequest2") {
                    data = data.map(function (item) {
                      return (0, _extends3.default)({}, item, { action: _this5.returnButton(item.status, item.planCaseNo, item.isDemandPaid) });
                    });
                  }
                  if (stateNameData == "cafRequest") {
                    data = data.map(function (item) {
                      return (0, _extends3.default)({}, item, { action: _this5.returnButtonCAF1(item.status, item.planCaseNo, item.isDemandPaid) });
                    });
                  }
                  if (stateNameData == "waterConnection") {
                    data = data.map(function (item) {
                      return (0, _extends3.default)({}, item, { action: _this5.returnButtonConnection(item.status, item.accountNo, item.connType) });
                    });
                  }

                  this.setState({
                    currentPage: page,
                    itemsPerPage: Math.min(20, data.length)
                  });
                  this.updateItemsRange();
                  layoutJsonNew = (0, _get2.default)(_store2.default.getState().moduleData, "layoutJson", {});

                  this.props.updateFieldValue(tableDataPath, data);
                  this.props.updateFieldValue(paginationDataPath, data);
                  this.props.updateFieldValue("layout[2].props.visible", true);
                  _store2.default.dispatch((0, _actions.prepareFinalObject)(stateName, data));
                } else {
                  message = res.data.hasOwnProperty("Errors") && res.data.Errors.length > 0 && res.data.Errors[0].message;

                  (0, _commons.showToast)(message, "error");
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSearch(_x3) {
        return _ref2.apply(this, arguments);
      }

      return handleSearch;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var data = this.props.data;
      var _state2 = this.state,
          currentPage = _state2.currentPage,
          itemsPerPage = _state2.itemsPerPage,
          itemsRangeStart = _state2.itemsRangeStart,
          itemsRangeEnd = _state2.itemsRangeEnd;

      // Logic for displaying current items

      var indexOfLastItem = currentPage * itemsPerPage;
      var indexOfFirstItem = indexOfLastItem - itemsPerPage;
      var currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

      // Logic for displaying page numbers
      var totalPages = Math.ceil(data.length / itemsPerPage);

      return _react2.default.createElement(
        "div",
        { className: "pagination-container" },
        this.state.loaderVisibility && _react2.default.createElement(_components.LoadingIndicator, null),
        _react2.default.createElement(
          "span",
          null,
          "Showing " + itemsRangeStart + "-" + itemsRangeEnd + " of " + itemsRangeEnd + " items"
        ),
        _react2.default.createElement(
          "ul",
          { className: "pagination" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "a",
              { onClick: function onClick(e) {
                  return _this6.handleClick(e, currentPage - 1);
                }, style: { marginRight: "10px" }, className: currentPage === 1 ? "disabled" : "" },
              "\xAB Prev"
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "a",
              { onClick: function onClick(e) {
                  return _this6.handleClick(e, currentPage + 1);
                }, className: currentPage === totalPages ? "" : "" },
              "Next \xBB"
            )
          )
        )
      );
    }
  }]);
  return CustomPagination;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    updatedLayoutJson: state.moduleData.layoutJson
  };
};

var mapDispatchToProps = {
  updateModule: _action.updateModule,
  initLayoutJson: _action.initLayoutJson,
  updateFieldValue: _action.updateFieldValue,
  updateLayoutJson: _action.updateLayoutJson
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CustomPagination);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/CustomPagination/index.js
// module id = 2142
// module chunks = 1137